import {createContext, useContext, useMemo} from 'react'

import {Refractory} from '@refra/modules/refra-catalog/types'

interface KilnShutdownsRefractoriesContextState {
  kilnShutdownsRefractories: Record<string, Refractory>
}

const KilnShutdownsRefractoriesContext = createContext<
  KilnShutdownsRefractoriesContextState | undefined
>(undefined)

export const useKilnShutdownsRefractories = () => {
  const context = useContext(KilnShutdownsRefractoriesContext)
  if (!context)
    throw new Error(
      'useKilnShutdownsRefractories is used outside of the KilnShutdownsRefractoriesProvider!'
    )
  return context
}

interface KilnShutdownsRefractoriesProviderProps {
  refractories: Refractory[]
  children: React.ReactNode
}

export const KilnShutdownsRefractoriesProvider: React.FC<
  KilnShutdownsRefractoriesProviderProps
> = ({refractories, children}) => {
  const kilnShutdownsRefractories: Record<string, Refractory> = useMemo(
    () =>
      refractories.reduce((acc, refractory) => {
        acc[refractory.id] = refractory
        return acc
      }, {}),
    [refractories]
  )

  return (
    <KilnShutdownsRefractoriesContext.Provider
      value={{
        kilnShutdownsRefractories
      }}
    >
      {children}
    </KilnShutdownsRefractoriesContext.Provider>
  )
}
